import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Search, Eye, Mail } from 'lucide-react';
import { StatusBadge, channelNames } from './shared';

export const MembershipsTab = ({
  filteredMemberships, searchQuery, setSearchQuery,
  statusFilter, setStatusFilter, viewMembershipDetail, handleSendRenewal
}) => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader>
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <CardTitle className="text-xl">Listado de Membresías</CardTitle>
            <CardDescription>{filteredMemberships.length} resultado(s)</CardDescription>
          </div>
          <div className="flex flex-wrap gap-3">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <Input
                placeholder="Buscar nombre, email, código..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-9 w-64"
                data-testid="search-memberships"
              />
            </div>
            <Select value={statusFilter} onValueChange={setStatusFilter}>
              <SelectTrigger className="w-40" data-testid="status-filter">
                <SelectValue placeholder="Filtrar" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todas</SelectItem>
                <SelectItem value="active">Activas</SelectItem>
                <SelectItem value="pending">Pendientes</SelectItem>
                <SelectItem value="consumed">Consumidas</SelectItem>
                <SelectItem value="expired">Expiradas</SelectItem>
                <SelectItem value="cancelled">Canceladas</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-gray-50">
                <TableHead className="font-semibold">Usuario</TableHead>
                <TableHead className="font-semibold">Email</TableHead>
                <TableHead className="font-semibold">Teléfono</TableHead>
                <TableHead className="font-semibold">Código</TableHead>
                <TableHead className="font-semibold">Estado</TableHead>
                <TableHead className="font-semibold">Canal</TableHead>
                <TableHead className="font-semibold">Fecha</TableHead>
                <TableHead className="font-semibold text-center">Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredMemberships.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} className="text-center py-12 text-gray-400">
                    {searchQuery ? 'No se encontraron resultados' : 'No hay membresías registradas'}
                  </TableCell>
                </TableRow>
              ) : (
                filteredMemberships.map((m) => (
                  <TableRow key={m.id} className="hover:bg-gray-50">
                    <TableCell className="font-medium">{m.user_name}</TableCell>
                    <TableCell className="text-gray-500 text-sm">{m.user_email}</TableCell>
                    <TableCell className="text-gray-500 text-sm">{m.user_phone || '-'}</TableCell>
                    <TableCell className="font-mono text-sm">{m.card_code}</TableCell>
                    <TableCell><StatusBadge status={m.status} /></TableCell>
                    <TableCell className="text-gray-500 text-sm">{channelNames[m.sales_channel] || m.sales_channel}</TableCell>
                    <TableCell className="text-gray-500 text-sm">{new Date(m.created_at).toLocaleDateString('es-MX')}</TableCell>
                    <TableCell className="text-center">
                      <div className="flex items-center justify-center gap-1">
                        <Button variant="ghost" size="sm" onClick={() => viewMembershipDetail(m.id)} data-testid={`view-detail-${m.id}`}>
                          <Eye className="w-4 h-4" />
                        </Button>
                        {(m.status === 'consumed' || m.status === 'expired') && (
                          <Button variant="ghost" size="sm" onClick={() => handleSendRenewal(m.id)} title="Enviar recordatorio">
                            <Mail className="w-4 h-4 text-amber-600" />
                          </Button>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};
